var render = function () {
  var _vm$lead, _vm$lead2, _vm$lead3, _vm$lead4, _vm$lead5, _vm$lead6, _vm$lead7, _vm$lead8, _vm$lead9, _vm$lead10, _vm$lead11, _vm$lead11$leadStatus, _vm$lead11$leadStatus2, _vm$lead12, _vm$lead12$leadStatus, _vm$lead12$leadStatus2, _vm$lead13, _vm$lead13$leadStatus, _vm$lead13$leadStatus2, _vm$lead14, _vm$lead15, _vm$lead15$leadStatus, _vm$lead15$leadStatus2, _vm$lead16, _vm$lead17, _vm$lead18, _vm$lead18$leadSource, _vm$lead18$leadSource2, _vm$lead19, _vm$lead20, _vm$lead20$leadCatego, _vm$lead20$leadCatego2, _vm$lead21, _vm$lead22, _vm$lead23, _vm$lead24, _vm$lead25, _vm$lead26, _vm$lead27, _vm$lead28, _vm$lead29, _vm$lead30, _vm$lead31, _vm$lead32, _vm$lead32$department, _vm$lead32$department2, _vm$lead33, _vm$lead34, _vm$lead34$accountMan, _vm$lead35, _vm$lead36, _vm$lead37, _vm$lead38, _vm$lead39, _vm$lead40, _vm$lead41, _vm$lead42, _vm$lead43, _vm$lead43$leadCountr, _vm$lead43$leadCountr2, _vm$lead44, _vm$lead45, _vm$lead46, _vm$lead47, _vm$lead48, _vm$lead49, _vm$lead49$leadStatus, _vm$lead49$leadStatus2, _vm$lead50, _vm$lead51, _vm$lead52, _vm$lead52$project, _vm$lead52$project$da, _vm$lead53, _vm$lead53$leadStatus, _vm$lead53$leadStatus2, _vm$lead54, _vm$lead54$leadStatus, _vm$lead54$leadStatus2, _vm$selectedLeadStatu, _vm$selectedLeadStatu2, _vm$selectedLeadStatu4, _vm$selectedLeadStatu5, _vm$selectedLeadStatu6, _vm$selectedLeadStatu7;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "lead-details-card"
  }, [_c('b-row', {
    staticClass: "justify-content-end mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm.$permissionAbility(_vm.LEAD_EDIT, _vm.permissions) ? [_c('b-button', {
    staticClass: "btn-icon rounded-circle",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.onShowEditLead(_vm.lead);
      }
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "Edit2Icon"
    }
  })], 1)] : _vm._e()], 2)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-row', {
    staticClass: "gy-3"
  }, [_vm._l([{
    label: 'Title',
    value: (_vm$lead = _vm.lead) === null || _vm$lead === void 0 ? void 0 : _vm$lead.title
  }, {
    label: 'Key Contact Person',
    value: (_vm$lead2 = _vm.lead) === null || _vm$lead2 === void 0 ? void 0 : _vm$lead2.key_contact_person
  }, {
    label: 'Company Name',
    value: (_vm$lead3 = _vm.lead) === null || _vm$lead3 === void 0 ? void 0 : _vm$lead3.company_name
  }], function (field, index) {
    return _c('b-col', {
      key: 'info1-' + index,
      staticClass: "mb-1",
      attrs: {
        "cols": "12",
        "sm": "6",
        "lg": "2"
      }
    }, [_c('h6', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(field.label))]), field.value ? _c('b-card-text', [_vm._v(_vm._s(field.value))]) : _c('b-card-text', [_vm._v("N/A")])], 1);
  }), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Email")]), (_vm$lead4 = _vm.lead) !== null && _vm$lead4 !== void 0 && _vm$lead4.email ? [_c('b-link', {
    attrs: {
      "href": 'mailto:' + ((_vm$lead5 = _vm.lead) === null || _vm$lead5 === void 0 ? void 0 : _vm$lead5.email)
    }
  }, [_vm._v(_vm._s((_vm$lead6 = _vm.lead) === null || _vm$lead6 === void 0 ? void 0 : _vm$lead6.email))])] : [_c('b-card-text', [_vm._v("N/A")])]], 2), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Website Link")]), (_vm$lead7 = _vm.lead) !== null && _vm$lead7 !== void 0 && _vm$lead7.website_link ? [_c('b-link', {
    attrs: {
      "href": (_vm$lead8 = _vm.lead) === null || _vm$lead8 === void 0 ? void 0 : _vm$lead8.website_link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s((_vm$lead9 = _vm.lead) === null || _vm$lead9 === void 0 ? void 0 : _vm$lead9.website_link))])] : [_c('b-card-text', [_vm._v("N/A")])]], 2), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Status")]), (_vm$lead10 = _vm.lead) !== null && _vm$lead10 !== void 0 && _vm$lead10.lead_status_id ? [_c('b-badge', {
    staticClass: "d-inline-block",
    style: {
      background: (_vm$lead11 = _vm.lead) === null || _vm$lead11 === void 0 ? void 0 : (_vm$lead11$leadStatus = _vm$lead11.leadStatus) === null || _vm$lead11$leadStatus === void 0 ? void 0 : (_vm$lead11$leadStatus2 = _vm$lead11$leadStatus.data) === null || _vm$lead11$leadStatus2 === void 0 ? void 0 : _vm$lead11$leadStatus2.color_code
    },
    attrs: {
      "pill": ""
    }
  }, [_vm._v(" " + _vm._s((_vm$lead12 = _vm.lead) === null || _vm$lead12 === void 0 ? void 0 : (_vm$lead12$leadStatus = _vm$lead12.leadStatus) === null || _vm$lead12$leadStatus === void 0 ? void 0 : (_vm$lead12$leadStatus2 = _vm$lead12$leadStatus.data) === null || _vm$lead12$leadStatus2 === void 0 ? void 0 : _vm$lead12$leadStatus2.name) + " ")]), ((_vm$lead13 = _vm.lead) === null || _vm$lead13 === void 0 ? void 0 : (_vm$lead13$leadStatus = _vm$lead13.leadStatus) === null || _vm$lead13$leadStatus === void 0 ? void 0 : (_vm$lead13$leadStatus2 = _vm$lead13$leadStatus.data) === null || _vm$lead13$leadStatus2 === void 0 ? void 0 : _vm$lead13$leadStatus2.type) == 2 && !((_vm$lead14 = _vm.lead) !== null && _vm$lead14 !== void 0 && _vm$lead14.estimation_sent) ? [_c('b-badge', {
    staticClass: "badge-glow",
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Estimation Not Sent")])] : ((_vm$lead15 = _vm.lead) === null || _vm$lead15 === void 0 ? void 0 : (_vm$lead15$leadStatus = _vm$lead15.leadStatus) === null || _vm$lead15$leadStatus === void 0 ? void 0 : (_vm$lead15$leadStatus2 = _vm$lead15$leadStatus.data) === null || _vm$lead15$leadStatus2 === void 0 ? void 0 : _vm$lead15$leadStatus2.type) == 2 && (_vm$lead16 = _vm.lead) !== null && _vm$lead16 !== void 0 && _vm$lead16.estimation_sent ? [_c('b-badge', {
    staticClass: "badge-glow",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.viewOnlyEstimationModal
    }
  }, [_vm._v(" Estimation Sent ")])] : _vm._e()] : _vm._e()], 2)], 2), _c('b-row', {
    staticClass: "gy-3"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Source")]), (_vm$lead17 = _vm.lead) !== null && _vm$lead17 !== void 0 && _vm$lead17.lead_source_id ? _c('b-card-text', [_vm._v(_vm._s((_vm$lead18 = _vm.lead) === null || _vm$lead18 === void 0 ? void 0 : (_vm$lead18$leadSource = _vm$lead18.leadSource) === null || _vm$lead18$leadSource === void 0 ? void 0 : (_vm$lead18$leadSource2 = _vm$lead18$leadSource.data) === null || _vm$lead18$leadSource2 === void 0 ? void 0 : _vm$lead18$leadSource2.name))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Category")]), (_vm$lead19 = _vm.lead) !== null && _vm$lead19 !== void 0 && _vm$lead19.lead_category_id ? _c('b-card-text', [_vm._v(_vm._s((_vm$lead20 = _vm.lead) === null || _vm$lead20 === void 0 ? void 0 : (_vm$lead20$leadCatego = _vm$lead20.leadCategory) === null || _vm$lead20$leadCatego === void 0 ? void 0 : (_vm$lead20$leadCatego2 = _vm$lead20$leadCatego.data) === null || _vm$lead20$leadCatego2 === void 0 ? void 0 : _vm$lead20$leadCatego2.name))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Mobile")]), (_vm$lead21 = _vm.lead) !== null && _vm$lead21 !== void 0 && _vm$lead21.mobile ? [_c('b-link', {
    attrs: {
      "href": 'tel:' + ((_vm$lead22 = _vm.lead) === null || _vm$lead22 === void 0 ? void 0 : _vm$lead22.mobile)
    }
  }, [_vm._v(_vm._s((_vm$lead23 = _vm.lead) === null || _vm$lead23 === void 0 ? void 0 : _vm$lead23.mobile))])] : _vm._e()], 2), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Tel")]), (_vm$lead24 = _vm.lead) !== null && _vm$lead24 !== void 0 && _vm$lead24.phone ? [_c('b-link', {
    attrs: {
      "href": 'tel:' + ((_vm$lead25 = _vm.lead) === null || _vm$lead25 === void 0 ? void 0 : _vm$lead25.phone)
    }
  }, [_vm._v(_vm._s((_vm$lead26 = _vm.lead) === null || _vm$lead26 === void 0 ? void 0 : _vm$lead26.phone))])] : [_c('b-card-text', [_vm._v("N/A")])]], 2), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Listing Date")]), (_vm$lead27 = _vm.lead) !== null && _vm$lead27 !== void 0 && _vm$lead27.created_at ? _c('b-card-text', [_vm._v(" " + _vm._s(_vm.formatDate((_vm$lead28 = _vm.lead) === null || _vm$lead28 === void 0 ? void 0 : _vm$lead28.created_at)) + " ")]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Next Contact")]), (_vm$lead29 = _vm.lead) !== null && _vm$lead29 !== void 0 && _vm$lead29.next_contact_date ? _c('b-card-text', [_vm._v(" " + _vm._s(_vm.formatDate((_vm$lead30 = _vm.lead) === null || _vm$lead30 === void 0 ? void 0 : _vm$lead30.next_contact_date)) + " ")]) : _c('b-card-text', [_vm._v("N/A")])], 1)], 1), _c('b-row', {
    staticClass: "gy-3 mt-2"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Department")]), (_vm$lead31 = _vm.lead) !== null && _vm$lead31 !== void 0 && _vm$lead31.department_id ? _c('b-card-text', [_vm._v(_vm._s((_vm$lead32 = _vm.lead) === null || _vm$lead32 === void 0 ? void 0 : (_vm$lead32$department = _vm$lead32.department) === null || _vm$lead32$department === void 0 ? void 0 : (_vm$lead32$department2 = _vm$lead32$department.data) === null || _vm$lead32$department2 === void 0 ? void 0 : _vm$lead32$department2.name))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Key Contact Manager")]), (_vm$lead33 = _vm.lead) !== null && _vm$lead33 !== void 0 && _vm$lead33.team ? _c('b-card-text', [_c('UserCard', {
    attrs: {
      "user": (_vm$lead34 = _vm.lead) === null || _vm$lead34 === void 0 ? void 0 : (_vm$lead34$accountMan = _vm$lead34.accountManager) === null || _vm$lead34$accountMan === void 0 ? void 0 : _vm$lead34$accountMan.data
    }
  })], 1) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Assigned To")]), (_vm$lead35 = _vm.lead) !== null && _vm$lead35 !== void 0 && _vm$lead35.team ? _c('b-card-text', _vm._l(_vm.lead.team.data, function (item, index) {
    return _c('span', {
      key: index
    }, [_c('UserCard', {
      attrs: {
        "user": item
      }
    })], 1);
  }), 0) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Address")]), (_vm$lead36 = _vm.lead) !== null && _vm$lead36 !== void 0 && _vm$lead36.address ? _c('b-card-text', [_vm._v(" " + _vm._s((_vm$lead37 = _vm.lead) === null || _vm$lead37 === void 0 ? void 0 : _vm$lead37.address)), _c('br'), _vm._v(" State: " + _vm._s(((_vm$lead38 = _vm.lead) === null || _vm$lead38 === void 0 ? void 0 : _vm$lead38.state) || "N/A") + ", City: " + _vm._s(((_vm$lead39 = _vm.lead) === null || _vm$lead39 === void 0 ? void 0 : _vm$lead39.city) || "N/A") + ","), _c('br'), _vm._v(" Street: " + _vm._s(((_vm$lead40 = _vm.lead) === null || _vm$lead40 === void 0 ? void 0 : _vm$lead40.street) || "N/A") + ", Zip: " + _vm._s(((_vm$lead41 = _vm.lead) === null || _vm$lead41 === void 0 ? void 0 : _vm$lead41.zip_code) || "N/A") + " ")]) : _vm._e()], 1)], 1), _c('b-row', {
    staticClass: "gy-3 mt-2"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Country")]), (_vm$lead42 = _vm.lead) !== null && _vm$lead42 !== void 0 && _vm$lead42.country_id ? _c('b-card-text', [_vm._v(_vm._s((_vm$lead43 = _vm.lead) === null || _vm$lead43 === void 0 ? void 0 : (_vm$lead43$leadCountr = _vm$lead43.leadCountry) === null || _vm$lead43$leadCountr === void 0 ? void 0 : (_vm$lead43$leadCountr2 = _vm$lead43$leadCountr.data) === null || _vm$lead43$leadCountr2 === void 0 ? void 0 : _vm$lead43$leadCountr2.name))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Note")]), _c('b-card-text', [_vm._v(_vm._s(((_vm$lead44 = _vm.lead) === null || _vm$lead44 === void 0 ? void 0 : _vm$lead44.note) || "N/A"))])], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Business Card (Front)")]), (_vm$lead45 = _vm.lead) !== null && _vm$lead45 !== void 0 && _vm$lead45.business_card_front ? [_c('b-img', {
    staticClass: "img-fluid rounded shadow-sm",
    attrs: {
      "src": (_vm$lead46 = _vm.lead) === null || _vm$lead46 === void 0 ? void 0 : _vm$lead46.business_card_front
    }
  })] : [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "danger"
    }
  }, [_vm._v("N/A")])]], 2), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "text-capitalize"
  }, [_vm._v("Business Card (Back)")]), (_vm$lead47 = _vm.lead) !== null && _vm$lead47 !== void 0 && _vm$lead47.business_card_back ? [_c('b-img', {
    staticClass: "img-fluid rounded shadow-sm",
    attrs: {
      "src": (_vm$lead48 = _vm.lead) === null || _vm$lead48 === void 0 ? void 0 : _vm$lead48.business_card_back
    }
  })] : [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "danger"
    }
  }, [_vm._v("N/A")])]], 2)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12",
      "cols": "12"
    }
  }, [_c('b-card', [_c('div', [((_vm$lead49 = _vm.lead) === null || _vm$lead49 === void 0 ? void 0 : (_vm$lead49$leadStatus = _vm$lead49.leadStatus) === null || _vm$lead49$leadStatus === void 0 ? void 0 : (_vm$lead49$leadStatus2 = _vm$lead49$leadStatus.data) === null || _vm$lead49$leadStatus2 === void 0 ? void 0 : _vm$lead49$leadStatus2.type) == 2 ? [_c('b-alert', {
    attrs: {
      "variant": "success",
      "show": ""
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v(" This lead has been converted successfully & locked! "), ((_vm$lead50 = _vm.lead) === null || _vm$lead50 === void 0 ? void 0 : _vm$lead50.estimation_sent) == false ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 ml-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.showEstimationModal
    }
  }, [_vm._v(" Financial Estimation ")])] : _vm._e(), ((_vm$lead51 = _vm.lead) === null || _vm$lead51 === void 0 ? void 0 : _vm$lead51.estimation_sent) == true && ((_vm$lead52 = _vm.lead) === null || _vm$lead52 === void 0 ? void 0 : (_vm$lead52$project = _vm$lead52.project) === null || _vm$lead52$project === void 0 ? void 0 : (_vm$lead52$project$da = _vm$lead52$project.data) === null || _vm$lead52$project$da === void 0 ? void 0 : _vm$lead52$project$da.status) == false ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 ml-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.showEstimationModal
    }
  }, [_vm._v(" Edit Financial Estimation ")])] : _vm._e()], 2)])] : ((_vm$lead53 = _vm.lead) === null || _vm$lead53 === void 0 ? void 0 : (_vm$lead53$leadStatus = _vm$lead53.leadStatus) === null || _vm$lead53$leadStatus === void 0 ? void 0 : (_vm$lead53$leadStatus2 = _vm$lead53$leadStatus.data) === null || _vm$lead53$leadStatus2 === void 0 ? void 0 : _vm$lead53$leadStatus2.type) == 3 ? [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v(" This lead has been lost & locked! ")])])] : _vm._e(), _c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_vm.$permissionAbility(_vm.LEAD_ACTIVITY_CREATE, _vm.permissions) ? [((_vm$lead54 = _vm.lead) === null || _vm$lead54 === void 0 ? void 0 : (_vm$lead54$leadStatus = _vm$lead54.leadStatus) === null || _vm$lead54$leadStatus === void 0 ? void 0 : (_vm$lead54$leadStatus2 = _vm$lead54$leadStatus.data) === null || _vm$lead54$leadStatus2 === void 0 ? void 0 : _vm$lead54$leadStatus2.type) == 1 ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.newLogModal
    }
  }, [_vm._v(" Create Activity Log ")])] : _vm._e()] : _vm._e()], 2)]), _c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "style-class": "vgt-table lead-details-table striped condensed",
      "total-rows": _vm.totalRecords,
      "is-loading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        multipleColumns: true,
        initialSortBy: [{
          field: 'last_contact_date',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$row, _props$column2, _props$column3, _props$row4, _props$row4$leadStatu, _props$row4$leadStatu2, _props$row5, _props$row5$leadStatu, _props$row5$leadStatu2, _props$column4, _props$row6, _props$row6$created_b, _props$column5, _props$column6;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_file' ? [((_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.file.length) > 0 ? _c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-sm",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              var _props$row2;
              return _vm.showAttachmentModal((_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.file);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "DownloadIcon"
          }
        })], 1) : [_c('b', [_vm._v("No Files To Download")])]] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_remarks' ? [_c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-sm",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              var _props$row3;
              return _vm.showDescriptionModal((_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.remarks);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "InfoIcon"
          }
        })], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) === 'format_lead_status' ? [_c('b-badge', {
          style: {
            background: props === null || props === void 0 ? void 0 : (_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : (_props$row4$leadStatu = _props$row4.leadStatus) === null || _props$row4$leadStatu === void 0 ? void 0 : (_props$row4$leadStatu2 = _props$row4$leadStatu.data) === null || _props$row4$leadStatu2 === void 0 ? void 0 : _props$row4$leadStatu2.color_code
          },
          attrs: {
            "pill": ""
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row5 = props.row) === null || _props$row5 === void 0 ? void 0 : (_props$row5$leadStatu = _props$row5.leadStatus) === null || _props$row5$leadStatu === void 0 ? void 0 : (_props$row5$leadStatu2 = _props$row5$leadStatu.data) === null || _props$row5$leadStatu2 === void 0 ? void 0 : _props$row5$leadStatu2.name) + " ")])] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column4 = props.column) === null || _props$column4 === void 0 ? void 0 : _props$column4.field) === 'format_created_by' ? [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : (_props$row6$created_b = _props$row6.created_by) === null || _props$row6$created_b === void 0 ? void 0 : _props$row6$created_b.name) + " ")] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column5 = props.column) === null || _props$column5 === void 0 ? void 0 : _props$column5.field) === 'action' ? _c('span', [_vm.$permissionAbility(_vm.LEAD_ACTIVITY_EDIT, _vm.permissions) ? [_c('span', {
          on: {
            "click": function click($event) {
              return _vm.onShow(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "Edit2Icon",
            "title": "Edit",
            "variant": "warning",
            "size": "16"
          }
        })], 1)] : _vm._e(), _vm.$permissionAbility(_vm.LEAD_ACTIVITY_DELETE, _vm.permissions) ? [_c('span', {
          on: {
            "click": function click($event) {
              var _props$row7;
              return _vm.onDelete(props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : _props$row7.id);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "TrashIcon",
            "variant": "danger",
            "title": "Delete",
            "size": "16"
          }
        })], 1)] : _vm._e()], 2) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props === null || props === void 0 ? void 0 : (_props$column6 = props.column) === null || _props$column6 === void 0 ? void 0 : _props$column6.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props === null || props === void 0 ? void 0 : props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 2), _c('b-modal', {
    attrs: {
      "id": "description-modal",
      "centered": "",
      "title": "Remarks",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenDescriptionModal
    }
  }, [_c('b-card-text', [_vm._v(" " + _vm._s(_vm.modalDescription) + " ")])], 1), _c('b-modal', {
    attrs: {
      "id": "attachment-modal",
      "centered": "",
      "title": "Attachments",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenAttachmentModal
    }
  }, [_vm.selectedAttachments && Array.isArray(_vm.selectedAttachments) ? _c('b-card-text', [_c('b-row', _vm._l(_vm.selectedAttachments, function (fileUrl, index) {
    return _c('b-col', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "cols": "6"
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between"
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('b-link', {
      staticClass: "d-flex align-items-center",
      attrs: {
        "href": fileUrl.original_url,
        "target": "_blank"
      }
    }, [_c('feather-icon', {
      staticClass: "mr-2",
      attrs: {
        "icon": "DownloadIcon"
      }
    }), _vm._v(" Attachment ")], 1)], 1), _c('b-button', {
      staticClass: "ml-2",
      attrs: {
        "variant": "danger",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteAttachment(fileUrl);
        }
      }
    }, [_vm._v(" X ")])], 1)]);
  }), 1)], 1) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "modal-activity-log-show-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Edit Activity Log' : 'Create Activity Log ',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "leadActvityLogValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-row', [_vm.$permissionAbility(_vm.LEAD_ACTIVITY_EDIT, _vm.permissions) ? [_c('b-col', {
    attrs: {
      "md": "10",
      "lg": "10",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Lead Status ",
      "label-for": "leadStatusId"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "lead status",
      "vid": "lead_status_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          attrs: {
            "id": "division-id",
            "placeholder": "Assign a Status",
            "options": _vm.statusIdOption,
            "reduce": function reduce(country) {
              return country.id;
            },
            "label": "name"
          },
          on: {
            "input": _vm.checkForFinalStatus
          },
          model: {
            value: _vm.leadStatusId,
            callback: function callback($$v) {
              _vm.leadStatusId = $$v;
            },
            expression: "leadStatusId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 464460820)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2",
      "lg": "2",
      "xs": "12"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: 'Reset Status List!',
      expression: "'Reset Status List!'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn-icon rounded-circle mt-2",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.loadAllStatus
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "RefreshCcwIcon"
    }
  })], 1)], 1)] : _vm._e(), !_vm.$permissionAbility(_vm.LEAD_ACTIVITY_EDIT, _vm.permissions) ? [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Lead Status *",
      "label-for": "leadStatusId"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "lead status",
      "vid": "lead_status_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          attrs: {
            "id": "division-id",
            "placeholder": "Assign a Status",
            "options": _vm.statusIdOption,
            "reduce": function reduce(item) {
              return item.id;
            },
            "label": "name"
          },
          on: {
            "input": _vm.checkForFinalStatus
          },
          model: {
            value: _vm.leadStatusId,
            callback: function callback($$v) {
              _vm.leadStatusId = $$v;
            },
            expression: "leadStatusId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 4028786612)
  })], 1)], 1)] : _vm._e()], 2), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Contact Date & Time",
      "label-for": "contact_date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "contact date",
      "vid": "contact_date",
      "rules": 'required'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "id": "contact-date",
            "state": errors.length > 0 ? false : null,
            "config": _vm.contactDateConfig,
            "placeholder": "Select Date & Time"
          },
          model: {
            value: _vm.contactDate,
            callback: function callback($$v) {
              _vm.contactDate = $$v;
            },
            expression: "contactDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Contact Medium ",
      "label-for": "contact-through"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "contact medium",
      "vid": "contact_through",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('v-select', {
          attrs: {
            "id": "contact-through",
            "options": _vm.selectContactMediumOption,
            "reduce": function reduce(medium) {
              return medium.value;
            },
            "placeholder": "Choose A Contact Medium",
            "label": "text"
          },
          model: {
            value: _vm.contactMedium,
            callback: function callback($$v) {
              _vm.contactMedium = $$v;
            },
            expression: "contactMedium"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Remarks ",
      "label-for": "remarks"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "remarks",
      "vid": "remarks",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "remarks",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Meeting Remarks"
          },
          model: {
            value: _vm.remarks,
            callback: function callback($$v) {
              _vm.remarks = $$v;
            },
            expression: "remarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    class: {
      'required-label': ((_vm$selectedLeadStatu = _vm.selectedLeadStatus) === null || _vm$selectedLeadStatu === void 0 ? void 0 : _vm$selectedLeadStatu.type) === 2
    },
    attrs: {
      "label": ((_vm$selectedLeadStatu2 = _vm.selectedLeadStatus) === null || _vm$selectedLeadStatu2 === void 0 ? void 0 : _vm$selectedLeadStatu2.type) === 2 ? 'Project Proposal' : 'Attach File',
      "label-for": "file"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "attachment",
      "rules": _vm.fileValidationRules,
      "vid": "lead_activity_log_file"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var _vm$selectedLeadStatu3;
        var errors = _ref6.errors;
        return [_c('b-form-file', {
          attrs: {
            "id": "file-".concat((_vm$selectedLeadStatu3 = _vm.selectedLeadStatus) === null || _vm$selectedLeadStatu3 === void 0 ? void 0 : _vm$selectedLeadStatu3.type),
            "multiple": "",
            "state": errors.length ? false : null,
            "placeholder": "Choose a file or drop it here...",
            "drop-placeholder": "Drop file here..."
          },
          on: {
            "change": _vm.handleFileChange
          },
          model: {
            value: _vm.file,
            callback: function callback($$v) {
              _vm.file = $$v;
            },
            expression: "file"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    class: {
      'required-label': ((_vm$selectedLeadStatu4 = _vm.selectedLeadStatus) === null || _vm$selectedLeadStatu4 === void 0 ? void 0 : _vm$selectedLeadStatu4.type) !== 2 && ((_vm$selectedLeadStatu5 = _vm.selectedLeadStatus) === null || _vm$selectedLeadStatu5 === void 0 ? void 0 : _vm$selectedLeadStatu5.type) !== 3
    },
    attrs: {
      "label": "Next Contact Date & Time",
      "label-for": "next_contact_date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "next contact date",
      "vid": "next_contact_date",
      "rules": ((_vm$selectedLeadStatu6 = _vm.selectedLeadStatus) === null || _vm$selectedLeadStatu6 === void 0 ? void 0 : _vm$selectedLeadStatu6.type) !== 2 && ((_vm$selectedLeadStatu7 = _vm.selectedLeadStatus) === null || _vm$selectedLeadStatu7 === void 0 ? void 0 : _vm$selectedLeadStatu7.type) !== 3 ? 'required' : ''
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "id": "next-contact-date",
            "state": errors.length > 0 ? false : null,
            "config": _vm.contactDateConfig,
            "placeholder": "Select Date & Time"
          },
          model: {
            value: _vm.nextContactDate,
            callback: function callback($$v) {
              _vm.nextContactDate = $$v;
            },
            expression: "nextContactDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isLeadActivityFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1), _c('FinancialEstimationForm', {
    attrs: {
      "selected-lead-info": _vm.selectedLeadInfo,
      "lead-title": _vm.leadTitle,
      "lead-data": _vm.lead,
      "view-only": _vm.viewOnly
    },
    on: {
      "closed": _vm.hideEstimationModal,
      "loadLeadInfo": function loadLeadInfo($event) {
        return _vm.updateLeadInfo($event);
      }
    }
  })], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-lead-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Edit Lead  Details ' : _vm.modelType == 'copyModel' ? 'Copy Lead ' : 'Add Lead ',
      "hide-footer": "",
      "size": "lg",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenLeadEditModal
    }
  }, [_c('validation-observer', {
    ref: "leadValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationLeadForm($event);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Lead Title ",
      "label-for": "title"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "title",
      "vid": "title",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Lead Title"
          },
          model: {
            value: _vm.title,
            callback: function callback($$v) {
              _vm.title = $$v;
            },
            expression: "title"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-2 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('h5', [_vm._v("Lead Information")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Company Name ",
      "label-for": "company_name"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "company name",
      "vid": "company_name",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var errors = _ref9.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Company Name"
          },
          model: {
            value: _vm.company_name,
            callback: function callback($$v) {
              _vm.company_name = $$v;
            },
            expression: "company_name"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email ",
      "label-for": "email"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "company email",
      "vid": "email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var errors = _ref10.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "email",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Contact Email"
          },
          model: {
            value: _vm.email,
            callback: function callback($$v) {
              _vm.email = $$v;
            },
            expression: "email"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Country ",
      "label-for": "country_id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "country name",
      "vid": "country_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref11) {
        var errors = _ref11.errors;
        return [_c('v-select', {
          attrs: {
            "id": "division-id",
            "placeholder": "Choose here",
            "options": _vm.countryIdOption,
            "reduce": function reduce(item) {
              return item === null || item === void 0 ? void 0 : item.id;
            },
            "label": "name"
          },
          on: {
            "input": _vm.setDialCodeAsCountry
          },
          model: {
            value: _vm.country_id,
            callback: function callback($$v) {
              _vm.country_id = $$v;
            },
            expression: "country_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-10",
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Billing Address",
      "label-for": "billing_address"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "billing address",
      "vid": "billing_address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref12) {
        var errors = _ref12.errors;
        return [_c('div', {
          class: {
            fullscreen: _vm.isFullscreen
          }
        }, [_c('quill-editor', {
          staticClass: "custom-quill-editor",
          style: {
            width: '98% !important'
          },
          attrs: {
            "options": _vm.editorOption,
            "id": "billing_address",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Billing Address"
          },
          model: {
            value: _vm.billing_address,
            callback: function callback($$v) {
              _vm.billing_address = $$v;
            },
            expression: "billing_address"
          }
        }, [_c('div', {
          attrs: {
            "slot": "toolbar",
            "id": "toolbar"
          },
          slot: "toolbar"
        }, [_c('span', {
          staticClass: "ql-formats"
        }, [_c('button', {
          staticClass: "ql-bold"
        }, [_vm._v(" Bold ")]), _c('button', {
          staticClass: "ql-italic"
        }, [_vm._v(" Italic ")]), _c('button', {
          staticClass: "ql-underline"
        }, [_vm._v(" Underline ")]), _c('button', {
          staticClass: "ql-strike"
        }, [_vm._v(" Strike ")]), _c('button', {
          staticClass: "ql-blockquote"
        }), _c('button', {
          staticClass: "ql-list",
          attrs: {
            "value": "ordered"
          }
        }), _c('button', {
          staticClass: "ql-list",
          attrs: {
            "value": "bullet"
          }
        }), _c('button', {
          staticClass: "ql-script",
          attrs: {
            "value": "sub"
          }
        }), _c('button', {
          staticClass: "ql-script",
          attrs: {
            "value": "super"
          }
        }), _c('button', {
          staticClass: "ql-indent",
          attrs: {
            "value": "-1"
          }
        }), _c('button', {
          staticClass: "ql-indent",
          attrs: {
            "value": "+1"
          }
        }), _c('button', {
          staticClass: "ql-direction",
          attrs: {
            "value": "rtl"
          }
        }), _c('button', {
          staticClass: "ql-align",
          attrs: {
            "value": ""
          }
        }), _c('button', {
          staticClass: "ql-align",
          attrs: {
            "value": "center"
          }
        }), _c('button', {
          staticClass: "ql-align",
          attrs: {
            "value": "right"
          }
        }), _c('button', {
          staticClass: "ql-align",
          attrs: {
            "value": "justify"
          }
        }), _c('select', {
          staticClass: "ql-color"
        }), _c('select', {
          staticClass: "ql-background"
        }), _c('select', {
          staticClass: "ql-size"
        }, [_c('option', {
          attrs: {
            "value": "small"
          }
        }), _c('option', {
          attrs: {
            "selected": ""
          }
        }), _c('option', {
          attrs: {
            "value": "large"
          }
        }), _c('option', {
          attrs: {
            "value": "huge"
          }
        })]), _c('select', {
          staticClass: "ql-font"
        }), _c('select', {
          staticClass: "ql-header"
        }, [_c('option', {
          attrs: {
            "value": "1"
          }
        }, [_vm._v(" Heading 1 ")]), _c('option', {
          attrs: {
            "value": "2"
          }
        }, [_vm._v(" Heading 2 ")]), _c('option', {
          attrs: {
            "value": "3"
          }
        }, [_vm._v(" Heading 3 ")]), _c('option', {
          attrs: {
            "value": "4"
          }
        }, [_vm._v(" Heading 4 ")]), _c('option', {
          attrs: {
            "value": "5"
          }
        }, [_vm._v(" Heading 5 ")]), _c('option', {
          attrs: {
            "value": "6"
          }
        }, [_vm._v(" Heading 6 ")]), _c('option', {
          attrs: {
            "selected": ""
          }
        }, [_vm._v("Normal")])]), _c('button', {
          staticClass: "ql-link"
        }), _c('button', {
          staticClass: "fullscreen-btn",
          attrs: {
            "type": "button",
            "title": _vm.isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'
          },
          on: {
            "click": _vm.toggleFullscreen
          }
        }, [_vm._v(" 🔳 ")])])])])], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "7",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Company Address",
      "label-for": "address"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "company address",
      "vid": "address",
      "rules": "max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref13) {
        var errors = _ref13.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "address",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Company Address"
          },
          model: {
            value: _vm.address,
            callback: function callback($$v) {
              _vm.address = $$v;
            },
            expression: "address"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "5",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Company Website Link ",
      "label-for": "website_link"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "website link",
      "vid": "website_link"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref14) {
        var errors = _ref14.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "website_link",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Website Link"
          },
          model: {
            value: _vm.website_link,
            callback: function callback($$v) {
              _vm.website_link = $$v;
            },
            expression: "website_link"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "City",
      "label-for": "city"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "city",
      "vid": "city",
      "rules": "max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref15) {
        var errors = _ref15.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter City Name"
          },
          model: {
            value: _vm.city,
            callback: function callback($$v) {
              _vm.city = $$v;
            },
            expression: "city"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "State ",
      "label-for": "state"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "state",
      "vid": "state"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref16) {
        var errors = _ref16.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "state",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter State Name"
          },
          model: {
            value: _vm.state,
            callback: function callback($$v) {
              _vm.state = $$v;
            },
            expression: "state"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Street ",
      "label-for": "street"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "street",
      "vid": "street"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref17) {
        var errors = _ref17.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "street",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Street Name"
          },
          model: {
            value: _vm.street,
            callback: function callback($$v) {
              _vm.street = $$v;
            },
            expression: "street"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Zip Code ",
      "label-for": "zip_code"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "zip code",
      "vid": "zip_code"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref18) {
        var errors = _ref18.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "zip_code",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Zip Code"
          },
          model: {
            value: _vm.zip_code,
            callback: function callback($$v) {
              _vm.zip_code = $$v;
            },
            expression: "zip_code"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-2 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('h5', [_vm._v("Key Contact Person Information")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Person Name ",
      "label-for": "key_contact_person"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "person name",
      "vid": "key_contact_person",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref19) {
        var errors = _ref19.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "key_contact_person",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Person Name"
          },
          model: {
            value: _vm.keyContactPerson,
            callback: function callback($$v) {
              _vm.keyContactPerson = $$v;
            },
            expression: "keyContactPerson"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Dial Code ",
      "label-for": "dial_code_id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "dial code",
      "vid": "dial_code_country_id",
      "rules": _vm.mobile ? 'required' : ''
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref20) {
        var errors = _ref20.errors;
        return [_c('v-select', {
          attrs: {
            "id": "division-id",
            "placeholder": "Choose here",
            "options": _vm.dialCodeCountryIdOption,
            "reduce": function reduce(item) {
              return item === null || item === void 0 ? void 0 : item.id;
            },
            "label": "dial_code"
          },
          model: {
            value: _vm.dial_code_country_id,
            callback: function callback($$v) {
              _vm.dial_code_country_id = $$v;
            },
            expression: "dial_code_country_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Mobile",
      "label-for": "mobile"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "mobile",
      "vid": "mobile"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref21) {
        var errors = _ref21.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Number"
          },
          model: {
            value: _vm.mobile,
            callback: function callback($$v) {
              _vm.mobile = $$v;
            },
            expression: "mobile"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Telephone",
      "label-for": "phone"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tel",
      "vid": "phone"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref22) {
        var errors = _ref22.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Number"
          },
          model: {
            value: _vm.phone,
            callback: function callback($$v) {
              _vm.phone = $$v;
            },
            expression: "phone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-2 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('h5', [_vm._v("Lead Assignee Information")])])], 1), [_c('div', [_c('b-row', [_vm.modelType != 'editModel' ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Lead Status",
      "label-for": "lead_status_id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "lead status",
      "vid": "lead_status_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref23) {
        var errors = _ref23.errors;
        return [_c('v-select', {
          attrs: {
            "id": "division-id",
            "placeholder": "Select Status",
            "options": _vm.statusIdOption,
            "reduce": function reduce(item) {
              return item.id;
            },
            "label": "name"
          },
          model: {
            value: _vm.lead_status_id,
            callback: function callback($$v) {
              _vm.lead_status_id = $$v;
            },
            expression: "lead_status_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 77245892)
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Key Account Manager",
      "label-for": "kam"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "key account manager",
      "vid": "kam"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref24) {
        var errors = _ref24.errors;
        return [_c('v-select', {
          attrs: {
            "id": "kam",
            "placeholder": "Select Employee",
            "options": _vm.userIdOption,
            "reduce": function reduce(item) {
              return item === null || item === void 0 ? void 0 : item.id;
            },
            "label": "name"
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(data) {
              return [_vm.modelType == 'editModel' ? _c('div', {
                staticClass: "d-flex align-items-center"
              }, [_c('b-avatar', {
                staticClass: "mr-1",
                attrs: {
                  "src": (data === null || data === void 0 ? void 0 : data.avatar) === '' ? '/avatar.svg' : data === null || data === void 0 ? void 0 : data.avatar
                }
              }), _c('div', [_c('div', {
                staticClass: "font-weight-bolder"
              }, [_vm._v(" " + _vm._s(data === null || data === void 0 ? void 0 : data.name) + " "), _c('b-badge', {
                attrs: {
                  "pill": "",
                  "variant": "warning"
                }
              }, [_vm._v(_vm._s(data === null || data === void 0 ? void 0 : data.employee_number))])], 1), _c('div', {
                staticClass: "font-small-2"
              }, [_vm._v(_vm._s(data === null || data === void 0 ? void 0 : data.email))])])], 1) : _c('UserSelect', {
                attrs: {
                  "user": data
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.kam,
            callback: function callback($$v) {
              _vm.kam = $$v;
            },
            expression: "kam"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Assigned Employee",
      "label-for": "assign_users"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "assigned employee",
      "vid": "assign_users",
      "rules": _vm.modelType == 'editModel' ? '' : 'required'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref25) {
        var errors = _ref25.errors;
        return [_c('v-select', {
          attrs: {
            "id": "user-id",
            "placeholder": "Select Employee",
            "options": _vm.userIdOption,
            "reduce": function reduce(item) {
              return item === null || item === void 0 ? void 0 : item.id;
            },
            "label": "name",
            "multiple": ""
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(data) {
              return [_vm.modelType == 'editModel' ? _c('div', {
                staticClass: "d-flex align-items-center"
              }, [_c('b-avatar', {
                staticClass: "mr-1",
                attrs: {
                  "src": (data === null || data === void 0 ? void 0 : data.avatar) === '' ? '/avatar.svg' : data === null || data === void 0 ? void 0 : data.avatar
                }
              }), _c('div', [_c('div', {
                staticClass: "font-weight-bolder"
              }, [_vm._v(" " + _vm._s(data === null || data === void 0 ? void 0 : data.name) + " "), _c('b-badge', {
                attrs: {
                  "pill": "",
                  "variant": "warning"
                }
              }, [_vm._v(_vm._s(data === null || data === void 0 ? void 0 : data.employee_number))])], 1), _c('div', {
                staticClass: "font-small-2"
              }, [_vm._v(_vm._s(data === null || data === void 0 ? void 0 : data.email))])])], 1) : _c('UserSelect', {
                attrs: {
                  "user": data
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.assign_users,
            callback: function callback($$v) {
              _vm.assign_users = $$v;
            },
            expression: "assign_users"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Lead Source",
      "label-for": "lead_source_id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "lead source",
      "vid": "lead_source_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref26) {
        var errors = _ref26.errors;
        return [_c('v-select', {
          attrs: {
            "id": "head-id",
            "placeholder": "Select Source",
            "options": _vm.sourceIdOption,
            "reduce": function reduce(item) {
              return item === null || item === void 0 ? void 0 : item.id;
            },
            "label": "name"
          },
          model: {
            value: _vm.lead_source_id,
            callback: function callback($$v) {
              _vm.lead_source_id = $$v;
            },
            expression: "lead_source_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Lead Category",
      "label-for": "lead_category_id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "lead category",
      "vid": "lead_category_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref27) {
        var errors = _ref27.errors;
        return [_c('v-select', {
          attrs: {
            "id": "head-id",
            "placeholder": "Select Category",
            "options": _vm.categoryIdOption,
            "reduce": function reduce(item) {
              return item === null || item === void 0 ? void 0 : item.id;
            },
            "label": "name"
          },
          model: {
            value: _vm.lead_category_id,
            callback: function callback($$v) {
              _vm.lead_category_id = $$v;
            },
            expression: "lead_category_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "6",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Department",
      "label-for": "department_id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "department name",
      "vid": "department_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref28) {
        var errors = _ref28.errors;
        return [_c('v-select', {
          attrs: {
            "id": "division-id",
            "placeholder": "Select Department",
            "options": _vm.departmentIdOption,
            "reduce": function reduce(item) {
              return item === null || item === void 0 ? void 0 : item.id;
            },
            "label": "name"
          },
          model: {
            value: _vm.department_id,
            callback: function callback($$v) {
              _vm.department_id = $$v;
            },
            expression: "department_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1)], 1)], _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Note",
      "label-for": "note"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "note",
      "vid": "note",
      "rules": "max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref29) {
        var errors = _ref29.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "note",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Take A Quick Note"
          },
          model: {
            value: _vm.note,
            callback: function callback($$v) {
              _vm.note = $$v;
            },
            expression: "note"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.modelType === 'editModel' ? [_c('b-img', {
    staticClass: "small-image",
    attrs: {
      "src": _vm.business_card_front
    }
  })] : _vm._e()], 2), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.modelType === 'editModel' ? [_c('b-img', {
    staticClass: "small-image",
    attrs: {
      "src": _vm.business_card_back
    }
  })] : _vm._e()], 2), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Business Card (Front)",
      "label-for": "business_card_front"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Business Card (Front)",
      "rules": "size:2048|ext:jpeg,png,jpg",
      "vid": "business_card_front"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref30) {
        var errors = _ref30.errors;
        return [_c('b-form-file', {
          attrs: {
            "id": "business_card_front",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Choose a file or drop it here...",
            "drop-placeholder": "Drop file here..."
          },
          model: {
            value: _vm.business_card_front_input,
            callback: function callback($$v) {
              _vm.business_card_front_input = $$v;
            },
            expression: "business_card_front_input"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Business Card (Back)",
      "label-for": "business_card_back"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Business Card (Back)",
      "rules": "size:2048|ext:jpeg,png,jpg",
      "vid": "business_card_back"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref31) {
        var errors = _ref31.errors;
        return [_c('b-form-file', {
          attrs: {
            "id": "business_card_back",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Choose a file or drop it here...",
            "drop-placeholder": "Drop file here..."
          },
          model: {
            value: _vm.business_card_back_input,
            callback: function callback($$v) {
              _vm.business_card_back_input = $$v;
            },
            expression: "business_card_back_input"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm.isLeadsFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }